<template>
    <b-form-select
        :options="the_list"
        :state="input_state"
        :text-field="textField"
        :value-field="valueField"
        v-bind="$attrs"
        v-bind:value="value"
        v-on="inputListeners"
    >
        <template v-if="!$attrs.required" v-slot:first>
            <option :value="null">{{ blankOptionText }}</option>
        </template>
    </b-form-select>
</template>

<script>
import VuexInputFieldMixin from "./VuexInputFieldMixin";
import SelectInputMixin from "../private/SelectInputMixin";

export default {
    name: "OSelectInput",
    mixins: [VuexInputFieldMixin(true), SelectInputMixin],
};
</script>

<style scoped></style>
